import type { ApprovedCodeView } from "../types";

export type RegistrySlotName = ApprovedCodeView["slotName"];

export const SHARED_CODE_TABS: { slotName: RegistrySlotName; label: string }[] = [
  { slotName: "Filler", label: "Fillers" },
  { slotName: "Additive", label: "Additives" },
  { slotName: "Color", label: "Color" },
  { slotName: "Origin", label: "Recycle" },
];

export function sharedCodes(approvedCodes: ApprovedCodeView[]): ApprovedCodeView[] {
  return approvedCodes.filter((approvedCode) => approvedCode.slotName !== "Base");
}

export function codesInSlot(approvedCodes: ApprovedCodeView[], slotName: RegistrySlotName): ApprovedCodeView[] {
  return approvedCodes.filter((approvedCode) => approvedCode.slotName === slotName);
}

export function filterApprovedCodes(approvedCodes: ApprovedCodeView[], filterText: string): ApprovedCodeView[] {
  const searchText = filterText.trim().toLowerCase();
  if (!searchText) return approvedCodes;
  return approvedCodes.filter((approvedCode) =>
    [
      approvedCode.code,
      approvedCode.readsAs,
      approvedCode.slotName,
      approvedCode.resinFamilyCode,
      approvedCode.standardCode,
      approvedCode.approvedByDisplayName,
    ].some((value) => (value ?? "").toLowerCase().includes(searchText)),
  );
}
